<template>
  <div class="container">
    <el-form :inline="true">
        <el-form-item label="类型" prop="type">
          <el-select v-model="type" placeholder="类型">
            <el-option
              :label="v.name"
              v-for="(v, i) in stageType"
              :value="v.value"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addNew">新增</el-button>
          <el-button type="success" @click="refresh">同步数据</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="updateInfo(row)"
            >编辑</el-button
          >
        </div>
      </template>
    </auto-table>
  
    <stageEdit ref="add" @success="getList(1)"></stageEdit>
  </div>
</template>

<script>
import stageEdit from '../components/stageEdit.vue';
import { stageType } from "../components/dict";
export default {
  components:{
      stageEdit
  },
  data() {
    return {
        stageType,
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "步骤", value: "sort" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: '',
      type:'openShop'
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    addNew(){
      this.$refs.add.open()
    },

    updateInfo(row) {
       this.$refs.add.open(row)
    },
    refresh(){
        this.$get('/user/stage/redis',{type:this.type}).then(res=>{
            this.$message('成功')
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/stage/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          type: this.type || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>